import { useMemo } from "react"

import { getScriptURL, getApiURL, parseValue as parse } from "../utils"

export default function Source({ data, onLoad }) {
  const {
    pageId,
    siteId,
    pid,
    aid,
    sid1,
    sid2,
    sid3,
    first_name,
    last_name,
    email,
    address1,
    address2,
    city,
    state,
    zip,
    phone,
    country,
    dob_month,
    dob_day,
    dob_year,
    gender,
    mobile,
    optout = false,
    ...extraFields
  } = data

  const fields = useMemo(() => Object.entries(extraFields || {})
    .map(([key, value]) => `data.${key} = ${parse(value)};`)
    .join('\n'), [extraFields])

  return <iframe
    className="m-0 p-0 border-0"
    width="100%"
    height="100%"
    sandbox="allow-scripts allow-same-origin"
    onLoad={onLoad}
    srcDoc={`
<!DOCTYPE html>
<html>
  <head></head>
  <body>
    <script type="text/javascript" src="${getScriptURL()}"></script>
    <script type="text/javascript" id="userenroll-embed" class="userenroll-embed">
      (function(global) {
        function userenroll_load(){
          var data = {};

          data.siteId     = ${parse(siteId)};
          data.firstName  = ${parse(first_name)};
          data.lastName   = ${parse(last_name)};
          data.email      = ${parse(email)};
          data.address1   = ${parse(address1)};
          data.address2   = ${parse(address2)};
          data.city       = ${parse(city)};
          data.state      = ${parse(state)};
          data.zip        = ${parse(zip)};
          data.country    = ${parse(country)};
          data.phone      = ${parse(phone)};
          data.dobMonth   = ${parse(dob_month)};
          data.dobDay     = ${parse(dob_day)};
          data.dobYear    = ${parse(dob_year)};
          data.gender     = ${parse(gender)};
          data.mobile     = ${parse(mobile)};
          data.pid        = ${parse(pid)};
          data.aid        = ${parse(aid)};
          data.sid1       = ${parse(sid1)};
          data.sid2       = ${parse(sid2)};
          data.sid3       = ${parse(sid3)};

          data.optout   = ${parse(optout)};
          data.unsubscribed = false;

          data.pageOverride = ${parse(pageId)};
          data.embedUrlOverride = '${getApiURL()}';
          data.isTest = true;
          data.rurl = '';

          ${fields}

          global.userEnroll.initEmbed(data);
        }

        userenroll_load();
      })(this);
    </script>
  </body>
</html>
`}
  ></iframe>
}
